import { render, staticRenderFns } from "./module6.vue?vue&type=template&id=a60fd6a2&scoped=true"
import script from "./module6.vue?vue&type=script&lang=js"
export * from "./module6.vue?vue&type=script&lang=js"
import style0 from "./module6.vue?vue&type=style&index=0&id=a60fd6a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60fd6a2",
  null
  
)

export default component.exports